import { SET_CLASSROOMS, RESET, SET_CLASSROOM, SET_CLASSROOM_NAME } from './actionTypes'

function initialState( preserve = {} ) {
  return Object.assign({},{
    classrooms : {},
    classroomsSorted : [],
    classroom : { id: null, name: "", licenseKey:"", count:0 }
  }, preserve )
}

export default function (state = initialState(), action) {

  console.log('Classrooms - Reducer')

  switch (action.type) {
    case SET_CLASSROOM:
      state.classroom = action.classroom
      break;
    case SET_CLASSROOMS:
      state.classrooms = action.classrooms
      state.classroomsSorted = sortClassrooms ( { classrooms : action.classrooms } )
      break;
    case SET_CLASSROOM_NAME:
      state.classroom.name = action.name;
      break;

    case RESET:
      state = initialState()
  }

  return state
}

function sortClassrooms( options={} ) {
  var sortable=[]

  for (let [ id, classroom ] of Object.entries( options.classrooms ) ) {
      sortable.push( classroom )
  }

  if ( sortable.length ) sortable.sort( (a,b) => (( a.name ).toLowerCase() > ( b.name ).toLowerCase() ? 1 : -1 ) )

  return sortable
}